module.exports = __webpack_public_path__ + "static/media/Rectangle 10.67965a10.png";